export default "/assets/website/images/partners-bg.jpg?5b151d366c689524c1ece3f987e97f7a";